/*jslint browser: true, jquery: true */
$(document).ready(function() {
    // Slider novinek ve spodní části
    var $newsArticles = $('.news article'),
        $newsNavLinks = $('.newsNav a');

    function showNewsArticle(id) {
        $newsArticles.fadeOut(200, function() {
            $(this).removeClass('active');
        }).promise().done(function() {
            $newsArticles
                .filter(id)
                .fadeIn(200, function() { $(this).addClass('active'); });
        });
    }

    $newsNavLinks.click(function(evt) {
        evt.preventDefault();
        showNewsArticle($(this).attr('href'));
        $newsNavLinks.removeClass('active');
        $(this).addClass('active');
    });

    // Homepage slider

    var $hpSlides = $('.slides li'),
        $hpSliderLinks = $('.sliderNav button');

    $hpSliderLinks.click(function() {
        var index = $hpSliderLinks.index(this);
        $hpSlides.removeClass('active').eq(index).addClass('active');
        $hpSliderLinks.removeClass('active').eq(index).addClass('active');
    });

    // Rozevírání detailu služby a textu na HP

    $('.service .expand, .service .collapse, .service h2, .homepage .readMore, .homepage .collapse').click(function(evt) {
        var $article = $(this).closest('.service, .leftCol'),
            $wsw = $article.find('.wsw'),
            height;

        if(!$article.hasClass('expanded')) {
            if(typeof (height = $article.data('contentheight')) == 'undefined') {
                height = $wsw.height('auto').height();
                $wsw.height(0);
                $article.data('contentheight', height);
            }

            $wsw.animate({
                height: height
            }, 200);

            $article.addClass('expanded');
        } else {
            $wsw.animate({
                height: 0
            }, 200);
            $article.removeClass('expanded');
        }
        evt.preventDefault();
    });

    // Rozevírání testu (vlastně duplikát předchozího scriptu)

    $('.testStartBtn').click(function(evt) {
        var $test = $('#test'),
            $this = $(this),
            height;

        if(!$this.hasClass('expanded')) {
            if(typeof (height = $test.data('contentheight')) == 'undefined') {
                height = $test.height('auto').height();
                $test.height(0);
                $test.data('contentheight', height);
            }

            $test.animate({
                height: height
            }, 200);

            $('html, body').animate({
                scrollTop: $test.offset().top
            }, 400);

            $this.addClass('expanded').text($this.data('collapse-text'));
        } else {
            $test.animate({
                height: 0
            }, 200);
            $this.removeClass('expanded').text($this.data('expand-text'));
        }
        evt.preventDefault();
    });

    // Superfish pro menu

    $('#mainMenu > ul').superfish({
        delay: 500,
        speed: 'fast',
        speedOut: 'fast',
        cssArrows: true
    });

    // Shim pro klik na labely

    $("label").click(function(){
        if ($(this).attr("for") !== "")
            $("#" + $(this).attr("for")).click();
    });

    // Přepínání viditelnosti hlavního menu

    var $mainMenu = $('#mainMenu');
    $('.menuToggle').click(function() {
        $mainMenu.slideToggle(200);
    });

    $('.menuCollapse').click(function() {
        $mainMenu.slideUp(200);
    });

    var prevWinWidth,
        $window = $(window),
        currWinWidth = $window.innerWidth(),
        menuBreakpoint = 850,
        $searchInput = $('.searchBox .fText'),
        $searchSubmit = $('.searchBox .fSubmit'),
        searchToggle = function(evt) {
            evt.preventDefault();
            $searchInput.toggleClass('hidden');
        };

    if(currWinWidth < menuBreakpoint)
        $searchSubmit.on('click', searchToggle);
        $searchInput.addClass('hidden');

    $(window).on('resize', function() {
        prevWinWidth = currWinWidth;
        currWinWidth = $window.innerWidth();
        if (currWinWidth > menuBreakpoint && prevWinWidth <= menuBreakpoint) {
            $mainMenu.show();
            $searchSubmit.off('click', searchToggle);
        } else if (currWinWidth <= menuBreakpoint && prevWinWidth > menuBreakpoint) {
            $mainMenu.hide();
            $searchSubmit.on('click', searchToggle);
        }
    });

    // Rozevření jazyků na klik

    var $lang = $('#language');
    $lang.on('click', '.active', function(evt) {
        if($lang.hasClass('open')) { alert();
            return true;
        }

        evt.preventDefault();
        $lang.addClass('open');

    });

    $('body').on('click', function(evt) {
        if($(evt.target).is('#language, #language *')) {
            return true;
        }

        $lang.removeClass('open');
    });

    /* NewLogic personal footer */

    $('.nltoggle').on('click', function(e) {
        e.preventDefault();
        $(".nlcopyrights").stop().animate({
            opacity: 'toggle'
        }, 'slow');
    });

    // Otevření testu po odeslání

    var $testForm = $('#test');

    if($testForm.find('.q-err, .form-err, .field-err').length) {
        $('.testStartBtn').click();
        $('html, body').animate({
            scrollTop: $testForm.find('.final').offset().top - 400
        }, 250);
    }

    // speed form
    $('#speedFormButton').on('click', function(){
        $('.contact .form-err,.contact .form-ok').hide();

        var dataForm = $(this).closest('form').serialize();
        $.ajax({
            type: 'POST',
            url: '/www/templates/ajax/ajaxSpeedForm.php',
            data: {dataForm: dataForm, lang: $('html').attr('lang')},
            dataType: 'json'
        }).done(function(obj) {
            if (obj.error.contactMail == false) {
                $('#contactMail').addClass('field-err');
            } else {
                $('#contactMail').removeClass('field-err');
            }

            if (obj.error.contactMessage == false) {
                $('#contactMessage').addClass('field-err');
            } else {
                $('#contactMessage').removeClass('field-err');
            }

            // celkova kontrola hlasky
            if (obj.error.contactMail == false || obj.error.contactMessage == false) {
                $('.contact .form-err').show();
            } else {
                $('#contactMail').val('');
                $('#contactMessage').val('');
                $('.contact .form-ok').show();
                setTimeout(function() {
                    $('.contact .form-ok').hide();
                }, 2000);
            }
        });
        return false;
    });

    // newsletter
    $('#newsletterSubmit').on('click', function(){
        $('.newsletter .form-err,.newsletter .form-exists,.newsletter .form-ok').hide();
        $.ajax({
            type: 'POST',
            url: '/www/templates/ajax/ajaxNewsletter.php',
            data: {emailNewsletter: $('#emailNewsletter').val(), lang: $('html').attr('lang')},
            dataType: 'json'
        }).done(function(obj) {
            if (obj.valid == false) $('.newsletter .form-err').show();
            if (obj.exists == false) $('.newsletter .form-exists').show();

            if (obj.save == true) {
                $('.newsletter .form-ok').show();
                setTimeout(function() {
                    $('#emailNewsletter').val('');
                    $('.newsletter .form-ok').hide();
                }, 2000);
            }
        });
        return false;
    });

    // zobrazit dalsi clanky
    $('.loadMore').on('click', function(){
        $('.newsletter .form-err,.newsletter .form-exists,.newsletter .form-ok').hide();
        $.ajax({
            type: 'POST',
            url: '/www/templates/ajax/ajaxNextArticles.php',
            data: {page: $(this).attr('data-page'), numNews: $(this).attr('data-numNews'), uri: $(this).attr('data-uri'), lang: $('html').attr('lang')},
            dataType: 'json'
        }).done(function(obj) {
            if (obj.template) {
                $('.newsListing').append(obj.template);
            }

            var $button = $('button.loadMore');
            if (obj.count > 0) {
                $button.find('.count').html('('+ obj.count +')');
                $button.attr('data-page', obj.page);
                $button.attr('data-uri', obj.uri);
                $button.attr('data-numNews', obj.numNews);
            } else {
                $button.hide();
            }
        });
        return false;
    });
});
